import React from "react";
import { Modal, Button } from "react-bootstrap";

const InlineDeletePopUp = ({
  show,
  onConfirm,
  onCancel,
  message = "Are you sure you want to delete this item?",
}) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Body className="text-center">
        <h6>{message}</h6>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button
            className="d-flex align-items-center justify-content-center commonBtn btnSm w-100"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            className="d-flex align-items-center justify-content-center commonBtn btnSm w-100"
            onClick={onConfirm}
          >
            Yes, Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InlineDeletePopUp;
